import React from 'react'
import { useFeatureFlagCookieContext } from '@usap/core'
import getLastSkuETAForDifm from '../../../DIFM/utility/getLastSkuETAForDifm'
import useAllowedPartsFlag from '../../../DIFM/store/hooks/useAllowedPartsFlag'
import DetailsWmo from './DetailsWmo'

const Details = props => {
  const { data, tooltip, showLoader } = props
  const { items } = data
  const { allowedPartsForDifmMasterFilter } = useAllowedPartsFlag()
  const lastSkuEta = getLastSkuETAForDifm(data, true, allowedPartsForDifmMasterFilter)
  const {
    covidMessage: showShippingUpdate,
  } = useFeatureFlagCookieContext()

  return (
    <DetailsWmo
      showShippingUpdate={showShippingUpdate}
      items={items}
      tooltip={tooltip}
      lastSkuEta={lastSkuEta}
      data={data}
      showLoader={showLoader}
    />
  )
}

export default Details
